<template>
  <div class="skeleton-engagement-container">
    <div class="skeleton-engagement-header">
      <v-skeleton-loader
        type="text"
        width="100px"
        class="mr-6"
      />
      <DpplAutoSizedButton
        :height="36"
        :width="70"
        color="white"
        class="full-view-button"
      >
        View All
      </DpplAutoSizedButton>
    </div>
    <div class="skeleton-engagement-row table-header">
      <v-skeleton-loader
        type="text"
        width="72px"
        class="mr-6"
      />
      <div class="skeleton-engagement-right-col">
        <v-skeleton-loader
          v-for="(_, i) in Array(3)"
          :key="i"
          type="text"
          width="42px"
          class="ml-6"
        />
      </div>
    </div>
    <div
      v-for="(_, i) in Array(5)"
      :key="i"
      class="skeleton-engagement-row"
    >
      <v-skeleton-loader
        type="text"
        width="72px"
      />
      <div class="skeleton-engagement-right-col">
        <DpplSkeletonLoader
          v-for="(loader, index) in Array(3)"
          :key="index"
          class="mb-0"
        >
          <p class="skeleton-engagement-metric">
            0
          </p>
        </DpplSkeletonLoader>
      </div>
    </div>
  </div>
</template>

<script>

import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';

export default {
  name: 'EngagementSkeletonLoader',
  components: {
    DpplSkeletonLoader,
    DpplAutoSizedButton,
  },
};
</script>

<style lang="less" scoped>
@import '@/less/mixins';

.skeleton-engagement-container {
  background: @white;
  width: 354px;
  height: 100%;
  padding: 24px;
  border-radius: 10px;
  .shadow()
}

.skeleton-engagement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.skeleton-engagement-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid @stroke-default;
  &.table-header {
    padding: 16px 0;
  }
}

.skeleton-engagement-right-col {
  display: flex;
  justify-items: flex-end;
}
div:last-child {
  border-bottom: none;
}

p.skeleton-engagement-metric {
  color: @grey-500;
  width: 42px;
  text-align: center;
  margin-left: 24px;
  font-size: 12px !important;
  line-height: 16px !important;
}

.full-view-button.v-btn {
  border: 1px solid @stroke-default !important;
  pointer-events: none;
  opacity: 0.4;
  :deep(.v-btn__content) {
    font-size: 12px;
    font-weight: 500;
    color: @text-darkest;
  }
}

:deep(.skeleton-engagement-row) {
  div.v-skeleton-loader__text {
      margin-bottom: 0 !important;
  }
}

:deep(.v-skeleton-loader__bone) {
  margin: 0 !important;
}
</style>
